import SEOMeta from '@/components/feature/SEOMeta';
import { siteConfig } from '@/mocks/site';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteConfig.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <SEOMeta
        title={siteConfig.title}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
        ogImage="https://readdy.ai/api/search-image?query=Historical%20events%20collage%20artistic%20style%2C%20ancient%20manuscripts%20and%20modern%20history%2C%20warm%20amber%20tones%2C%20scholarly%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}